const tallyRouter = [
  {
    path: "tally",
    name: "tally",
    component: () => import("../pages/tally/Tally"),
    meta: {
      title: "PC点货",
    },
  },

  {
    path: "tally2",
    name: "tally2",
    component: () => import("../pages/tally/Tally2"),
    meta: {
      title: "PC点货_NEW",
    },
  },
  {
    path: "goods-out-of-log",
    name: "GoodsOutOfStock",
    component: () => import("../pages/log/GoodsOutOfStock.vue"),
    meta: {
      title: "商品库断货日志",
    },
  },
  {
    path: "re-da-biao",
    name: "ReDaBiao",
    component: () => import("../pages/tally/ReDaBiao"),
    meta: {
      title: "PC重打",
    },
  },
  //  无数据点货
  {
    path: "not_data_goods_tally",
    name: "notDataGoodsTally",
    component: () => import("../pages/nodatagoods/NoDataGoodsTally"),
    meta: {
      title: "无数据点货",
    },
  },

  // 新pc点货
  {
    path: "takeStock",
    name: "takeStock",
    component: () => import("../pages/takeStock/takeStock"),
    meta: {
      title: "PC点货-REMAKE",
    },
  },
  //  仓库盘盈
  {
    path: "tally/StorageSurplus",
    name: "StorageSurplus",
    component: () => import("../pages/tally/StorageSurplus"),
    meta: {
      title: "仓库盘盈",
    },
  },
];

export default tallyRouter;



// WEBPACK FOOTER //
// ./src/router/tallyRouter.js